import React from 'react';
import isString from 'lodash/isString';

import type { VehicleSpecification } from 'Pages/vehicles/helpers/vehicle.schema';

import styles from './Colour.module.scss';

interface ColourProps {
	value: VehicleSpecification['exterior'];
}

export const Colour: React.FC<ColourProps> = ({ value }) => {
	const hasValue = isString(value);

	return (
		<span className={styles.colour} data-value={hasValue ? value.toLowerCase() : 'other'}>
			{hasValue ? value : '-'}
		</span>
	);
};
